import {ChangeDetectorRef, Component, forwardRef, OnInit, ViewChild} from "@angular/core";
import {Manufacturer} from "../../../shared/view-model/crm/manufacturer";
import {FetchManufacturersResponse, ManufacturerService} from "../../services/manufacturer.service";
import {FormBuilder, FormControl} from "@angular/forms";
import {AbstractVisbosControl} from "../../../core/visbos-core/ui/forms/abstract-visbos-control";
import {appInjector} from "../../../index";
import {ManufacturerFormComponent} from "../manufacturer-form/manufacturer-form.component";
import {ApolloQueryObservable} from "apollo-angular";

@Component({
    selector: 'vb-manufacturer-selection',
    templateUrl: './manufacturer-selection.component.html',
    styleUrls: ['./manufacturer-selection.component.css'],
    providers: [{provide: AbstractVisbosControl, useExisting: forwardRef(() => ManufacturerSelectionComponent)}]
})
export class ManufacturerSelectionComponent extends AbstractVisbosControl<Manufacturer, FormControl> implements OnInit {

    @ViewChild(ManufacturerFormComponent)
    private manufacturerForm: ManufacturerFormComponent;

    private manufacturerList$: ApolloQueryObservable<FetchManufacturersResponse>;
    manufacturerList: Manufacturer[] = [];

    constructor(fb: FormBuilder, cd: ChangeDetectorRef,
                private manufacturerService: ManufacturerService) {
        super(fb, cd, null);
    }

    ngOnInit() {
        super.ngOnInit();

        this.manufacturerList$ = this.manufacturerService.getManufacturerList();
        this.addComponentData(this.manufacturerList$);
        this.dataSubscriptions.push(this.manufacturerList$.subscribe(res => this.manufacturerList = res.data.fetchManufacturers));

    }

    buildControlContent(): FormControl {
        return ManufacturerSelectionComponent.initControl(this.fb);
    }

    public static initControl(fb: FormBuilder = null): FormControl {
        fb = fb ? fb : appInjector().get(FormBuilder);
        return fb.control(null);
    }

    createManufacturer(data) {
        this.manufacturerForm.control.reset();
        this.manufacturerForm.reset(true);
        this.manufacturerService.createManufacturer(data);
    }

}



// WEBPACK FOOTER //
// ./src/app/crm/manufacturer/manufacturer-selection/manufacturer-selection.component.ts